import React, {useEffect, useState} from 'react';
import {updateNumOfMsgs, displayPopUp, setPopUpProps} from '../../../SelfCareSlice';
import {handleURL} from '../../../../../../utilities/StringHelpers/StringHelpers';
import {connect} from 'react-redux';
import BtnRightSideText from '../../../../../Shared/Buttons/BtnRightSideText';
import {
  RefundItem,
  TechnicianVisitItem,
  PlanChangeItem,
  ManagerCallItem,
  FollowUpRefundItem,
  AbroadPackageItem,
  CustomerDeliveriesItem,
  FinanceIssueItem,
  AbroadInsuranceItem,
  CouponReceivedItem,
} from './trackerItem';
import {setCurrentSubscriber} from '../../../../../Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import {isMobile} from 'react-device-detect';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import {showAppLoader, hideAppLoader} from '../../../../../Shared/Loader/LoaderSlice';
import gaParams from '../../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../../utilities/analytics/tracking';
import './tracker.scss';
import {insertMessageToReport} from './DWHReports';

SwiperCore.use([Navigation, Pagination]);

const Tracker = (props) => {
  const [ItemVisible, setItemVisible] = useState(props.selfCareSliceTracker.firstItemShown);
  useEffect(() => {
    if (props.selfCareSliceTracker.financeMessage && !props.selfCareSliceTracker.isFetchData) {
      insertReport();
    }
  }, [props.selfCareSliceTracker.financeMessage]);

  useEffect(() => {
    setItemVisible(props?.selfCareSliceTracker?.orderedTrackerItems[0]);
  }, [props.selfCareSliceTracker.orderedTrackerItems]);

  const [isShowMoreClicked, setIsShowMoreClicked] = useState(false);
  const [buttonText, setButtonText] = useState('הצג עוד עדכונים');

  const showMoreOrLessBtnClicked = () => {
    setIsShowMoreClicked(!isShowMoreClicked);
    if (isShowMoreClicked) {
      setButtonText('הצג עוד עדכונים');
    } else {
      setButtonText('הצג פחות');
    }
  };
  const insertReport = () => {
    let getBanFinanceIssueType = props.selfCareSliceTracker.orderedTrackerItems.find((x) => x._type == 'FinanceIssue');
    if (getBanFinanceIssueType) {
      insertMessageToReport(getBanFinanceIssueType.banFinanceIssueType);
    }
  };

  const OpenModal = (popUpProps) => {
    props.setPopUpProps(popUpProps);
    props.displayPopUp(true);
  };

  const navigateToPage = (url) => {
    handleURL(url, props.context);
  };

  const isFinanceIssueExist = () => {
    let financeIssueExist = props.selfCareSliceTracker.orderedTrackerItems.some((x) => x._type == 'FinanceIssue');
    return financeIssueExist;
  };

  const isTrackerButtonVisible = () => {
    if (isFinanceIssueExist() && !isMobile) {
      if (props.selfCareSliceTracker.isShowTracker) {
        return props.selfCareSliceTracker.numOfItems > props.selfCareSliceTracker.itemsToShow;
      } else {
        return true;
      }
    } else {
      return !isMobile && props.selfCareSliceTracker.numOfItems > props.selfCareSliceTracker.itemsToShow;
    }
  };

  const abroadInsuranceUrl = props?.epiData?.abroadInsuranceUrl?.value;

  return (
    <div className='tracker-container' style={{opacity: props.selfCareSliceTracker.isFetchData ? 0 : 1}}>
      {!isMobile && props.selfCareSliceTracker.numOfItems > 0 && (
        <>
          {ItemVisible?._type === 'FinanceIssue' && (
            <FinanceIssueItem
              {...ItemVisible}
              URLs={props.epiData}
              context={props.context}
              onItemClick={OpenModal}
              numOfItems={props.selfCareSliceTracker.numOfItems}
            />
          )}
          {ItemVisible?._type === 'Refund' && (
            <RefundItem {...ItemVisible} onItemClick={OpenModal} numOfItems={props.selfCareSliceTracker.numOfItems} />
          )}
          {ItemVisible?._type === 'FollowUpRefund' && (
            <FollowUpRefundItem {...ItemVisible} onItemClick={OpenModal} numOfItems={props.selfCareSliceTracker.numOfItems} />
          )}
          {ItemVisible?._type === 'ManagerCall' && (
            <ManagerCallItem
              {...ItemVisible}
              URLs={props.epiData}
              onItemClick={OpenModal}
              numOfItems={props.selfCareSliceTracker.numOfItems}
            />
          )}
          {ItemVisible?._type === 'AbroadPackage' && (
            <AbroadPackageItem
              {...ItemVisible}
              URLs={props.epiData}
              onItemClick={OpenModal}
              numOfItems={props.selfCareSliceTracker.numOfItems}
            />
          )}
          {ItemVisible?._type === 'PlanChange' && (
            <PlanChangeItem {...ItemVisible} onItemClick={OpenModal} numOfItems={props.selfCareSliceTracker.numOfItems} />
          )}
          {ItemVisible?._type === 'CustomerDeliveries' && (
            <CustomerDeliveriesItem {...ItemVisible} onItemClick={OpenModal} numOfItems={props.selfCareSliceTracker.numOfItems} />
          )}
          {ItemVisible?._type === 'AbroadInsurance' && (
            <AbroadInsuranceItem
              {...ItemVisible}
              onItemClick={OpenModal}
              abroadInsuranceUrl={abroadInsuranceUrl}
              context={props.context}
              subscriber={ItemVisible?.subscriber}
              ban={ItemVisible?.banId}
              name={props.userData?.userDetails?.firstName + ' ' + props.userData?.userDetails?.lastName}
              id={props.userData?.userDetails?.IDNumber}
              setCurrentSubscriber={props.setCurrentSubscriber}
              numOfItems={props.selfCareSliceTracker.numOfItems}
            />
          )}
          {ItemVisible?._type === 'TechnicianVisit' && (
            <TechnicianVisitItem
              {...ItemVisible}
              URLs={props.epiData}
              onItemClick={OpenModal}
              navigateToPage={navigateToPage}
              numOfItems={props.selfCareSliceTracker.numOfItems}
            />
          )}
          {ItemVisible?._type === 'CouponReceived' && (
            <CouponReceivedItem {...ItemVisible} onItemClick={OpenModal} numOfItems={props.selfCareSliceTracker.numOfItems} />
          )}
        </>
      )}
      {isMobile && props.selfCareSliceTracker.numOfItems > 0 && (
        <div>
          <div className={isShowMoreClicked ? 'tracker-swiper-container-open' : 'tracker-swiper-container'}>
            <Swiper
              id='tracker-swiper'
              direction={!isMobile ? 'vertical' : 'horizontal'}
              className={`${!props.selfCareSliceTracker.isShowTracker && !isMobile ? 'invisible' : 'visible '} ${
                isMobile ? '' : 'swiper-no-swiping'
              } swiper-of-tracker`}
              noSwiping={!isMobile ? true : false}
              width={!isMobile ? null : 380}
              spaceBetween={0}
              slidesPerView={1.1}
              navigation={isMobile ? {nextEl: '.tracker-show-more-next', prevEl: '.tracker-show-more-back'} : false}
              onInit={(el) => {
                console.log(el);
              }}
              pagination={
                isMobile
                  ? {
                      clickable: false,
                    }
                  : false
              }
              onSlideChange={(el) => {
                props.updateNumOfMsgs(el.activeIndex);
              }}>
              {props.selfCareSliceTracker.orderedTrackerItems.map((element, index) => {
                gaEvent(gaParams.PERSONAL_AREA_SHOW_TRACKER.category, gaParams.PERSONAL_AREA_SHOW_TRACKER.eventType, element._type);
                switch (element._type) {
                  case 'FinanceIssue':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <FinanceIssueItem
                          {...element}
                          URLs={props.epiData}
                          context={props.context}
                          onItemClick={OpenModal}
                          id={`FinanceIssue${index}`}
                        />
                      </SwiperSlide>
                    );
                  case 'Refund':
                    return (
                      <SwiperSlide key={element.isFinanceIssue + index}>
                        <RefundItem {...element} onItemClick={OpenModal} id={`Refund${index}`} />
                      </SwiperSlide>
                    );
                  case 'FollowUpRefund':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <FollowUpRefundItem {...element} onItemClick={OpenModal} id={`FollowUpRefund${index}`} />
                      </SwiperSlide>
                    );
                  case 'AbroadPackage':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <AbroadPackageItem {...element} URLs={props.epiData} onItemClick={OpenModal} id={`AbroadPackage${index}`} />
                      </SwiperSlide>
                    );
                  case 'PlanChange':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <PlanChangeItem {...element} onItemClick={OpenModal} id={`PlanChange${index}`} />
                      </SwiperSlide>
                    );
                  case 'CustomerDeliveries':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <CustomerDeliveriesItem {...element} onItemClick={OpenModal} id={`CustomerDeliveries${index}`} />
                      </SwiperSlide>
                    );
                  case 'AbroadInsurance':
                    return (
                      <SwiperSlide key={element.id + index}>
                        <AbroadInsuranceItem
                          {...element}
                          onItemClick={OpenModal}
                          abroadInsuranceUrl={abroadInsuranceUrl}
                          context={props.context}
                          subscriber={element.subscriber}
                          ban={element.banId}
                          name={props.userData?.userDetails?.firstName + ' ' + props.userData?.userDetails?.lastName}
                          id={props.userData?.userDetails?.IDNumber || `AbroadInsurance${index}`}
                          setCurrentSubscriber={props.setCurrentSubscriber}
                        />
                      </SwiperSlide>
                    );
                  case 'TechnicianVisit':
                    return (
                      <SwiperSlide key={element.id}>
                        <TechnicianVisitItem
                          {...element}
                          URLs={props.epiData}
                          onItemClick={OpenModal}
                          navigateToPage={navigateToPage}
                          id={`TechnicianVisit${index}`}
                        />
                      </SwiperSlide>
                    );
                  case 'CouponReceived':
                    return (
                      <SwiperSlide key={element.id}>
                        <CouponReceivedItem {...ItemVisible} onItemClick={OpenModal} numOfItems={props.selfCareSliceTracker.numOfItems} />
                      </SwiperSlide>
                    );
                }
              })}
            </Swiper>
          </div>
          {isTrackerButtonVisible() && !isMobile ? (
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              <BtnRightSideText
                customClass={!isShowMoreClicked ? 'tracker-show-more-btn' : 'tracker-show-more-btn tracker-show-more-btn-open'}
                isGreyBg={true}
                isDisplayArrows={false}
                text={buttonText}
                onclick={() => showMoreOrLessBtnClicked()}></BtnRightSideText>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selfCareSliceTracker: state.selfcarePage.selfCareData.trackers,
    userData: state.authentication?.loginData,

    // isShowTracker: initState.isShowTracker,
  };
};

const mapDispatchToProps = {
  updateNumOfMsgs,
  showAppLoader,
  hideAppLoader,
  displayPopUp,
  setPopUpProps,
  setCurrentSubscriber,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tracker);
